import controller from './change-payment-result.controller';

export default {
  controller,
  template: require('./change-payment-result.html')
};



// WEBPACK FOOTER //
// src/app/buy/change-payment-result-dialog/change-payment-result.component.ts